export const assistant = {
routeTitle: "مساعد العمليات",
routeSubtitle: "معلومات العمليات لأصولك",
inputModeText: "النص أولاً",
widget: {
showLess: "عرض أقل",
showMore: "عرض المزيد",
openAssistant: "فتح المساعد",
live: "مباشر",
assistantLabel: "المساعد",
headerSubtitle: "اسأل، أو افحص، أو جدوِل، أو أعد التعيين، أو أنشئ عملًا دون مغادرة هذه الشاشة.",
newConversation: "محادثة جديدة",
close: "إغلاق",
newThread: "موضوع جديد",
loadingConversation: "جارٍ تحميل المحادثة...",
emptyTitle: "الدردشة التشغيلية الدائمة",
emptyBody: "ابدأ بتعليمات طبيعية. يمكن للمساعد الإجابة على الأسئلة واقتراح الإجراءات وانتظار تأكيدك عندما يكون هناك تغيير مهم.",
actorYou: "أنت",
actorAssistant: "المساعد",
usedWorkspaceData: "بيانات مساحة العمل المستخدمة",
recommendationFallbackTitle: "توصية",
dictationInserting: "جارٍ إدراج النص…",
dictationFinishing: "جارٍ إنهاء الإملاء…",
dictationHeard: "ما سُمع: {{transcript}}",
dictationListening: "جارٍ الاستماع…",
messageInputLabel: "قم بمراسلة المساعد",
messagePlaceholder: "اطرح سؤالاً أو أخبر المساعد بما يجب عليه فعله",
messagePlaceholderShort: "اسأل أو اطلب من المساعد…",
stopDictation: "إيقاف الإملاء الصوتي",
dictateMessage: "إملاء الرسالة",
sendingMessage: "إرسال الرسالة",
sendMessage: "أرسل رسالة",
sending: "جارٍ الإرسال…",
send: "إرسال",
composerHintPhone: "اضغط على الميكروفون للإملاء.",
composerHintDesktop: "اضغط على الميكروفون للإملاء. في لوحات المفاتيح الفعلية، يُرسل `Enter` الرسالة؛ ويضيف `Shift + Enter` سطرًا جديدًا.",
},
conversation: {
newSession: "جلسة جديدة",
inputModeLabel: "وضع الإدخال: {{mode}}",
modeHint: "جاهز للإدخال الصوتي؛ الإدخال النصي هو النشط الآن.",
retry: "إعادة المحاولة",
loadingHistory: "جارٍ تحميل سجل المساعد...",
emptyTitle: "المساعد التشغيلي",
emptyBody: "اطلب مسودات قائمة التحقق، أو جدولة الفحص، أو إنشاء أمر العمل، أو حالة العمل، أو إعادة التعيين، أو شرح المخاطر، أو توصيات الخطوة التالية.",
actorYou: "أنت",
actorAssistant: "المساعد",
messagePlaceholder: "اطلب من المساعد إنشاء أو شرح أو فحص أو التوصية أو إعادة التعيين",
},
quickPrompts: {
attention: "ما الذي يحتاج إلى اهتمامي الآن؟",
inspectionTemplates: "أين أدير قوائم التحقق؟",
requestsTriage: "ما الطلبات التي تحتاج إلى فرز؟",
overdueJobs: "اعرض لي المهام المتأخرة",
assetNextStep: "ما الذي يجب أن أفعله بعد ذلك بشأن هذا الأصل؟",
assetOverdueInspections: "هل توجد فحوصات متأخرة لهذا الأصل؟",
assetRiskSummary: "لخّص المخاطر والعمل المفتوح على هذا الأصل",
scheduleNextInspection: "جدول الفحص التالي",
assetTopNextStep: "أوصِ بالخطوة التالية الأعلى أولوية لهذا الأصل",
assetOpenJobsFirst: "ما المهام المفتوحة التي يجب أن أراجعها أولًا؟",
shouldScheduleInspection: "هل يجب أن أجدول فحصًا؟",
requestSummarize: "لخّص هذا الطلب واقترح طريقة الرد عليه",
requestToJob: "حوّل هذا الطلب إلى مهمة",
requestMissingInfo: "ما المعلومات التي لا تزال ناقصة لبدء العمل؟",
requestOwner: "من يجب أن يتولى هذا الطلب؟",
requestFastestPath: "ما أسرع طريقة لتحويل هذا الطلب؟",
requestDraftResponse: "اكتب مسودة رد احترافي على مقدّم الطلب",
requestJobOrInspection: "هل يجب أن يصبح هذا مهمة أم فحصًا؟",
inspectionFailedFindings: "لخّص النتائج غير الناجحة واقترح مهام متابعة",
inspectionMissingEvidence: "ما الأدلة الناقصة في هذا الفحص؟",
inspectionHighestRisk: "اشرح البنود غير الناجحة الأعلى خطورة",
inspectionJobsFromUrgent: "أنشئ مهام من النتائج العاجلة",
jobBlocking: "ما الذي يعيق إكمال هذه المهمة؟",
jobNextUpdate: "اقترح التحديث التالي الذي يجب أن أنشره",
jobWhoElse: "من غيري يجب أن يشارك في هذه المهمة؟",
jobFollowUp: "ما أعمال المتابعة التي قد تكون مطلوبة؟",
jobNextStepToClose: "أوصِ بالخطوة التالية لإغلاق هذه المهمة",
jobDraftCompletionNote: "اكتب مسودة ملاحظة الإنجاز",
jobCreateFollowUp: "هل يجب أن أنشئ مهمة متابعة؟",
templateImprove: "كيف يمكنني تحسين هذا قائمة التحقق؟",
templateMissingChecks: "ما بنود التحقق الناقصة لهذا النوع من الأصول؟",
templateWeekly: "أنشئ قائمة تحقق فحص أسبوعيًا عمليًا",
templateWhereManage: "أين أدير قوائم التحقق في التطبيق؟",
},
  card: {
    edit: 'تعديل',
    doneEditing: 'تم',
    editHint: 'غيّر ما تريد قبل التأكيد.',
    confirming: 'جارٍ التأكيد…',
    dismiss: 'تجاهل',
    working: 'جارٍ التنفيذ…',
    undo: 'تراجع',
    undoing: 'جارٍ التراجع…',
    undone: 'تم التراجع',
    undoHint: 'يمكنك التراجع عن هذا خلال 10 دقائق.',
    edited: 'معدَّل',
    fields: {
      name: 'الاسم',
      description: 'الوصف',
      placeType: 'نوع المكان',
      address: 'العنوان',
      externalId: 'المرجع',
      code: 'الرمز',
      scheduledDate: 'الاستحقاق (التاريخ والوقت)',
      notes: 'ملاحظات',
      title: 'العنوان',
      dueDate: 'الاستحقاق (التاريخ والوقت)',
      estimatedCost: 'التقدير',
      note: 'تحديث',
      responseText: 'الرد',
    },
  },
  chart: {
    summary_zero: '{{title}}: من {{from}} إلى {{to}}',
    summary_one: '{{title}}: {{from}}',
    summary_two: '{{title}}: من {{from}} إلى {{to}}، نقطتان',
    summary_few: '{{title}}: من {{from}} إلى {{to}}، {{count}} نقاط',
    summary_many: '{{title}}: من {{from}} إلى {{to}}، {{count}} نقطة',
    summary_other: '{{title}}: من {{from}} إلى {{to}}، {{count}} نقطة',
  },
  context: {
    selectedAssets_zero: "السؤال عن {{count}} أصل محدد",
    selectedAssets_one: "السؤال عن أصل واحد محدد",
    selectedAssets_two: "السؤال عن أصلين محددين",
    selectedAssets_few: "السؤال عن {{count}} أصول محددة",
    selectedAssets_many: "السؤال عن {{count}} أصلًا محددًا",
    selectedAssets_other: "السؤال عن {{count}} أصل محدد",
    leaveOut: "استبعاد التحديد",
  },
  memory: {
    title: "ما يتذكره المساعد",
    intro: "تفضيلات لمساحة العمل كلها، مثل الأسماء التي تستخدمونها أو من يتولى عادة نوعًا من الأعمال. يتبعها المساعد عند الإجابة. يمكن لكل من في مساحة العمل رؤيتها.",
    empty: "لا شيء بعد. أضف تفضيلًا هنا أو اطلب من المساعد، مثلًا «تذكّر أن أعمال سلامة الغاز تذهب إلى Northside Heating».",
    addPlaceholder: "شيء يجب أن يتذكره المساعد",
    add: "إضافة",
    edit: "تعديل",
    save: "حفظ",
    cancel: "إلغاء",
    forget: "نسيان",
    viaAssistant: "أضيف عبر المساعد",
    added: "أضافه شخص في مساحة العمل",
    full: "يتذكر المساعد {{max}} عنصرًا، وهو الحد الأقصى. انسَ واحدًا لإضافة آخر.",
    saveFailed: "لم يتم الحفظ. يمكنك تغيير ما أضفته أنت فقط، إلا إذا كنت مسؤولًا عن مساحة العمل.",
  },
  offline: {
    waiting: "أنت غير متصل. سيُرسل هذا عند عودتك إلى الاتصال.",
    sending: "عدت متصلًا. جارٍ الإرسال…",
    fromGuide: "ريثما تنتظر، قد يساعدك دليل التطبيق:",
    discard: "عدم الإرسال",
    photoNeedsConnection: "الصورة تحتاج إلى اتصال. أزلها ليُرسل السؤال عند عودتك إلى الاتصال، أو حاول حينها.",
    queueFull: "هناك 10 أسئلة تنتظر الإرسال بالفعل. انتظر حتى تعود متصلًا.",
  },
  stream: {
    thinking: "جارٍ العمل على ذلك…",
    lookingUp_zero: "جارٍ البحث في البيانات…",
    lookingUp_one: "جارٍ البحث في البيانات ({{count}} حتى الآن)…",
    lookingUp_two: "جارٍ البحث في البيانات ({{count}} حتى الآن)…",
    lookingUp_few: "جارٍ البحث في البيانات ({{count}} حتى الآن)…",
    lookingUp_many: "جارٍ البحث في البيانات ({{count}} حتى الآن)…",
    lookingUp_other: "جارٍ البحث في البيانات ({{count}} حتى الآن)…",
  },
  voice: {
    readAloud: "قراءة الردود بصوت عالٍ",
    stopReading: "إيقاف قراءة الردود",
    readingAloud: "تُقرأ الردود بصوت عالٍ.",
    handsFree: "بدون استخدام اليدين",
    handsFreeOn: "بدون استخدام اليدين: بعد كل رد يستمع إلى سؤالك التالي.",
  },
  briefing: {
    title: 'هذا الأسبوع',
    stopSuggesting: 'توقف عن اقتراح هذا',
    hideWeek: 'إخفاء حتى الأسبوع القادم',
    turnOff: 'إيقاف الملخص الأسبوعي',
    settingsTitle: 'ملخصك الأسبوعي',
    settingsIntro: 'ملخص قصير لأسبوعك وبعض الأسئلة المقترحة أعلى المساعد. هذا إعدادك الخاص.',
    on: 'تشغيل',
    off: 'إيقاف',
    suggestionsOff_zero: 'لا توجد اقتراحات متوقفة.',
    suggestionsOff_one: 'نوع واحد من الاقتراحات متوقف.',
    suggestionsOff_two: 'نوعان من الاقتراحات متوقفان.',
    suggestionsOff_few: '{{count}} أنواع من الاقتراحات متوقفة.',
    suggestionsOff_many: '{{count}} نوعًا من الاقتراحات متوقفًا.',
    suggestionsOff_other: '{{count}} نوع من الاقتراحات متوقف.',
    suggestionsBackOn: 'إعادة تشغيل الاقتراحات',
  },
  photo: {
    add: "إضافة صورة",
    replace: "استبدال الصورة",
    remove: "إزالة الصورة",
    attached: "تم إرفاق الصورة. يقرؤها المساعد مرة واحدة ولا يحتفظ بها.",
    addTitle: "إضافة صورة",
    addBody: "التقط صورة أو اختر واحدة. يقرأ المساعد لوحات البيانات والقراءات والأضرار.",
    take: "التقاط صورة",
    choose: "اختيار صورة",
    cancel: "إلغاء",
    permissionTitle: "الإذن مطلوب",
    cameraPermissionBody: "اسمح بالوصول إلى الكاميرا من الإعدادات لالتقاط صورة للمساعد.",
    libraryPermissionBody: "اسمح بالوصول إلى الصور من الإعدادات لاختيار صورة للمساعد.",
    failedTitle: "لم تتم إضافة الصورة",
    failedBody: "تعذّر فتح هذه الصورة. جرّب صورة أخرى.",
    defaultMessage: "ماذا تُظهر هذه الصورة؟",
  },
  activity: {
    title: 'نشاط المساعد',
    subtitleAdmin: 'كل التغييرات التي تمت عبر المساعد في مساحة العمل هذه',
    subtitleMember: 'التغييرات التي أجريتها عبر المساعد',
    policyTitle: 'من يمكنه إجراء تغييرات عبر المساعد',
    policyIntroAdmin: 'يحتفظ كل شخص بصلاحياته: لا يفعل المساعد إلا ما يمكن للشخص فعله في التطبيق.',
    policy: {
      everyone: 'الجميع',
      admins: 'المالكون والمسؤولون',
      nobody: 'لا أحد',
    },
    policyHelp: {
      everyone: 'يمكن للأعضاء تأكيد التغييرات التي يعدّها المساعد ضمن صلاحياتهم.',
      admins: 'يمكن للأعضاء طرح الأسئلة؛ ولا يؤكد التغييرات إلا المالكون والمسؤولون.',
      nobody: 'يجيب المساعد وينصح لكنه لا يغيّر شيئًا. تُرسل طلبات الميزات كالمعتاد.',
    },
    policyMember: {
      everyone: 'يمكنك تأكيد التغييرات التي يعدّها المساعد ضمن صلاحياتك.',
      admins: 'في مساحة العمل هذه لا يجري التغييرات عبر المساعد إلا المالكون والمسؤولون. لا يزال بإمكانك سؤاله.',
      nobody: 'أوقفت مساحة العمل هذه التغييرات عبر المساعد. لا يزال بإمكانك سؤاله.',
    },
    saving: 'جارٍ الحفظ…',
    saveFailed: 'تعذّر حفظ هذا الإعداد.',
    loadFailed: 'تعذّر تحميل نشاط المساعد.',
    refresh: 'تحديث',
    count_zero: 'لا توجد تغييرات',
    count_one: 'تغيير واحد',
    count_two: 'تغييران',
    count_few: '{{count}} تغييرات',
    count_many: '{{count}} تغييرًا',
    count_other: '{{count}} تغيير',
    empty: 'لا توجد تغييرات عبر المساعد بعد.',
    status: {
      executed: 'تم',
      failed: 'فشل',
      undone: 'تم التراجع',
    },
    byYou: 'بواسطتك',
    byPerson: 'بواسطة {{name}}',
  },
};
